import { useMediaQuery } from "react-responsive";
import { useTheme } from "styled-components";

export const useMobileMediaQuery = () => {
  const theme = useTheme();
  return useMediaQuery({ query: theme.media.mobile.split(" and ")[1] });
};
